import React from 'react'
import { ReactComponent as FaqsIcon } from '../settings/assets/faqs.svg';
import { ReactComponent as SupportIcon } from '../../assets/support.svg';
import { useThemeColor } from '../../hooks/useThemeColor';

const HilfeSidebar = ({ onSelect, selectedComponent }) => {
  const { aispaceColor } = useThemeColor();

  return (
    <div
      className="h-full w-[250px] flex flex-col font-semibold border-r border-gray-200 bg-[#FBFBFF] pl-5 pr-5 pt-10 pb-4"
      style={{ minHeight: '90vh' }}
    >
      <div 
        className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
          ${selectedComponent === 'faqs' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
        onClick={() => onSelect('faqs')}
      >
        <span className={selectedComponent === 'faqs' ? 'navbar-icon-selected' : 'navbar-icon'}>
          <FaqsIcon fill={selectedComponent === 'faqs' ? aispaceColor : '#5F6368'} />
        </span>
        <span className="navbar-text">FAQs</span>
      </div>

      <div 
        className={`flex px-4 py-2 text-sm gap-2 items-center text-custom-gray cursor-pointer transition-colors duration-200 mb-2 h-10
          ${selectedComponent === 'support' ? 'nav-btn-selected font-bold shadow-md' : 'nav-btn-unselected hover:bg-[#f1f1f1]'}`}
        onClick={() => onSelect('support')}
      >
        <span className={selectedComponent === 'support' ? 'navbar-icon-selected' : 'navbar-icon'}>
          <SupportIcon fill={selectedComponent === 'support' ? aispaceColor : '#5F6368'} />
        </span>
        <span className="navbar-text">Support</span>
      </div>

      <div className="text-xs text-gray-500 mt-auto mb-20">
        DocAI V2.2<br/>
        © 2025 AI Spaces GmbH
      </div>
    </div>
  )
}

export default HilfeSidebar
